<template>
  <section class="flex justify-between pt-[var(--navbar-height)]">
    <BlocksHeroBreadcrumbs :breadcrumbs="breadcrumbs" class="my-auto" />
  </section>
</template>

<script>
export default {
  name: 'CommunityHeader',
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
      default: () => [],
      validator: val => val.every(item => item && item.title)
    }
  },
  data () {
    return {
      triggerChange: false,
      countries: [],
      loading: false
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>
